import React, {
  useEffect,
  useState,
  useLayoutEffect,
  useImperativeHandle,
  useContext,
} from "react"; 
import URLstateContext from "../../provider/CommonContext";
import {
  GetMethodData,
  DecryptAESdata,
  GetPostMethodData,
} from "../../provider/ServiceProvider";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";
// import facebook from "../../images/facebook.png";
// import twitter from "../../images/twitter.png";
import instagram from "../../images/instagram.svg";
import linkedin from "../../images/linkedin.svg";
import Facebook from "../../images/newIcon/facebook.svg"
import Whatsapp from "../../images/newIcon/whatsapp.svg"
import youtubeIcon from "../../images/newIcon/Youtube.svg";
import AboutBanner from "../AboutUs/AboutBanner/AboutBanner";
import { useNavigate, useLocation } from "react-router-dom";
import MaxTax from "../../PDF/MF_Tax_Update_Post_Union_Budget.pdf";
import CorporatePresentation from "../../PDF/Corporate Presentation April 2026.pdf";
import IncapacitatedInvestor from "../../PDF/Form of Incapacitated Investor.pdf";
import { Modal, Button } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import Alternative from "../../PDF/Alternative Investment Funds.pdf";
import NavMethodology from "../../PDF/Methodology of NAV compuation of Mutual Fund Scheme.pdf";

function Footer() {
  const { BaseURL, BaseURLShare } = useContext(URLstateContext);
  let navigate = useNavigate();
  const [data, setData] = useState("");
  const [show, setShow] = useState(false); //updated
  const [smsShow, setSmsShow] = useState(false); //updated
  const [DataMisc, setDataMisc] = useState("");
  const [SubCategoryName, setSubCategoryName] = useState(
    "Scheme Expense Ratio",
  );
  const currentYear = new Date().getFullYear();

  const handleClosePopup = () => {
    setShow(false);
  };

  const handleOpenPopup = () => {
    setShow(true);
  };

  const handleCloseSmsPopup = () => {
    setSmsShow(false);
  };

  const handleOpenSmsPopup = () => {
    setSmsShow(true);
  };

  const getNavLink = () => {
    const hostname = window.location.hostname;

    if (hostname.includes("cmotswebnew")) {
      // UAT environment
      return "http://cmotswebnew:715/NAVs-and-IDCW/NAV";
    } else {
      // Live environment
      return "https://www.jmfinancialmf.com/NAVs-and-IDCW/NAV";
    }
  };

  // useEffect(() => {
  //     GetPostMethodData(BaseURL + "GetJmfBranchaes", {
  //         "IVbranchtype": 'HO',
  //         "IVzone": '',
  //         "IVcity": ''
  //     }).then((data) => {
  //         if (data.data != null && data.data.length > 0) {
  //             setData(DecryptAESdata(data.data));
  //             // if(citys != ""){
  //             //     setDataCities(DecryptAESdata(data.data))
  //             // }
  //             //   }, 500);
  //         } useEffect(() => { GetPostMethodData()})

  //     });
  // }, [BaseURL]);

  useEffect(() => {
    GetPostMethodData(BaseURL + "Getmiscellaneous", {
      IVSubCategoryName: "Scheme Expense Ratio",
    })
      .then((data) => {
        if (data.data != null && data.data.length > 0) {
          setDataMisc(DecryptAESdata(data.data));
        }
      })
      .catch((error) => {
        //  console.log(error);
      });
  }, []);

  const handleChange = () => {
    let path = "/Reach-Us/Get-In-Touch";
    let widthWindow = window.matchMedia("(max-width: 500px)");
    navigate(path, { state: { plan: "reachus" } });
    if (widthWindow.matches) {
      window.scrollTo({
        top: 2000,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 1200,
        behavior: "smooth",
      });
    }
  };
  // const handleTER = () =>{
  //     navigate('/TERRatio')
  // }

  return (
    <>
      <section className="footer-sc" aria-label="Footer Section">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="footer-menu-main">
                <div className="footer-menu">
                  <p className="footer-heading">About Us</p>
                  {/* <h4>About Us</h4> */}
                  <ul>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/JM-Financial">
                        JM Financial{" "}
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/AMC">
                        AMC
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        href={CorporatePresentation}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Corporate Presentation
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/Teams">
                        Teams
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/TrusteeBoard">
                        Trustee Board
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/AMC-Board">
                        The AMC Board
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/Sponsor">
                        Sponsor{" "}
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/Auditors">
                        Auditors of the Fund
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/Custodian">
                        Custodian{" "}
                      </a>
                    </li>
                    <li>
                      <a className="cursorpointer" href="/AboutUs/Registrar">
                        Registrar{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        href={Alternative}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Alternative Investment Funds{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        href="/RegistrationDetails"
                        // target="_blank"
                        rel="noopener noreferrer"
                      >
                        Registration Details{" "}
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Downloads</p>
                  <ul>
                    <li>
                      <a href="downloads/Forms"> </a>
                    </li>
                    <li>
                      <a href="downloads/Factsheet">Factsheet</a>
                    </li>
                    <li>
                      <a href="downloads/Product-Literature">
                        Product Literature
                      </a>
                    </li>
                    <li>
                      <a href="downloads/Scheme-Related-Documents">
                        Scheme Related Documents
                      </a>
                    </li>
                    <li>
                      <a href="downloads/Notice-and-Addendums">Notice/Addendums</a>
                    </li>
                    <li>
                      <a href="downloads/Portfolio-Disclosure">
                        Portfolio Disclosure
                      </a>
                    </li>
                    {/* <li><a href="/">KYC Norms</a></li> */}
                    <li>
                      <a href="downloads/Statutory-Disclosure">
                        Statutory Disclosure
                      </a>
                    </li>
                    <li>
                      <a href="downloads/Scheme-Financials">
                        Scheme Financials
                      </a>
                    </li>

                    {/* <li><a href="">Scheme Summary Document</a></li>
                                        <li><a href="">SAI & Amendments</a></li> */}
                    {/* <li><a href="downloads/Other-disclosure">Other disclosure</a></li>
                                        <li><a href="downloads/Scheme-related-documents">Scheme related documents</a></li> */}
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">NAVs</p>
                  <ul>
                    <li>
                      <a href="NAVs-and-IDCW/NAV">NAV</a>
                    </li>
                    <li>
                      <a href="NAVs-and-IDCW/IDCW">IDCW (Dividend)</a>
                    </li>
                    <li>
                      <a href="/SmsCodeForScheme">SMS code for scheme </a>
                    </li>
                    {/* <li>
                      <a
                        href="javascript:void(0)"
                        onClick={() => handleOpenSmsPopup()}
                      >
                        SMS code for scheme
                      </a>
                    </li> */}
                    <li>
                      <a href="/downloads/Statutory-Disclosure/Unclaimed-Redemption-Dividend-Details">
                        Unclaimed Redemption & IDCW (Dividend)
                      </a>
                    </li>
                    <li>
                      <a href="/downloads/Statutory-Disclosure/Disclosure-of-Various-Payment-Options-along-with-their-efficiency-for-the-purpose-of-NAV-applicability">
                        Payment Efficacy Matrix
                      </a>
                    </li>
                    <li>
                      <a
                        href={NavMethodology}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Methodology of Computation of NAV
                      </a>
                    </li>
                    {/* PopUp for SMS Code Scheme Maintenance  */}
                    <Modal
                      show={smsShow}
                      onHide={handleCloseSmsPopup}
                      backdrop="static"
                      keyboard={true}
                      centered
                      className="modal modal-home"
                    >
                      <Modal.Body id="modal_info">
                        <div className="btnDiv">
                          <div className="" onClick={handleCloseSmsPopup}>
                            <AiFillCloseCircle className="btncl" />
                          </div>
                        </div>
                        <div style={{ padding: "10px" }}>
                          <p className="modal_info">
                            Please note, this service is currently unavailable.
                            To know the NAV for your scheme you may visit{" "}
                            <a
                              href={getNavLink()}
                              // target="_blank"
                              // rel="noopener noreferrer"
                            >
                              NAV page
                            </a>
                            .
                          </p>
                        </div>
                      </Modal.Body>
                    </Modal>
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Insights</p>
                  <ul>
                    {/* <li><a href='FinQ/Mutual-Fund-Basics'>Mutual fund Basics </a></li> */}
                    {/* <li><a href='FinQ/Sip'>SIP/STP/SWP</a></li> */}
                    {/* <li>
                      <a href="FinQ/Investor-Awareness-Program">
                        Investor Awareness Program
                      </a>
                    </li>
                    <li>
                      <a href="FinQ/IAP-Download">IAP Download</a>
                    </li> */}
                    <li>
                      <a href="Insights/Video-Gallery">Video Gallery</a>
                    </li>
                    <li>
                      <a href="Insights/Document-Gallery">Document Gallery</a>
                    </li>

                    {/* <li>
                      <a href={MaxTax} target="_blank" rel="noreferrer">
                        MF Tax Reckoner
                      </a>
                    </li> */}

                    {/* <li>
                      <a href="/new-blog">
                        New Blog Page
                      </a>
                    </li> */}

                    {/* <li>
                      <a
                        target="_blank"
                        href="https://mfs.kfintech.com/investor/general/validatekyc?amccode=57AB0A35-31CA-4190-A184-63949AA0E299"
                      >
                        Check Your KYC Status{" "}
                      </a>
                    </li>
                    <li>
                      <a href={SEBI} target="_blank">
                        FAQ's KYC Norms For The Securities Market{" "}
                      </a>
                    </li> */}
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Partner Corner</p>
                  <ul>
                    <li>
                      <a
                        className="cursorpointer"
                        href="https://onboarding.jmfinancialmf.com/login"
                        target="blank"
                      >
                        {" "}
                        Online Individual / Non-Individual Empanelment
                      </a>
                    </li>
                    {/* <li><a className='cursorpointer' href="https://onboarding.jmfinancialmf.com" target="blank"> Online Non-Individual Empanelment</a></li> */}
                    <li>
                      <a
                        className="cursorpointer"
                        href="PartnersCorner/OfflineEmpanelment"
                      >
                        Offline Empanelment
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        href="https://dit.jmfinancialmf.com/portal/login"
                        target="blank"
                      >
                        Transaction Platform
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        href="https://dit.jmfinancialmf.com/easylink"
                        target="blank"
                      >
                        Generate Easy Link{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        href="/PartnersCorner/ProcessAndService "
                      >
                        Process and Services{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        // href="https://docviewer.jmfinancialmf.com/cobranded/"
                        href="https://jmcobrand.anchoredgetechno.com/"
                        target="blank"
                      >
                        Co-Branded Collaterals{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="cursorpointer"
                        href="https://www.jmfinancialmf.com/static/media/Final%20Ready%20Reckoner%20for%20MFDs%20shared%20with%20AMCs%20(10-Feb-25).bec2c8a9f6b7a61f37c4.pdf"
                        target="blank"
                      >
                        Ready Reckoner for Mutual Fund Distributors{" "}
                      </a>
                    </li>

                    <li>
                      <a
                        className="cursorpointer"
                        // href="/Distributor-Empanelment-Details"
                        href="https://mfs.kfintech.com/investor/General/distributerCorner?AMCCODE=57AB0A35-31CA-4190-A184-63949AA0E299"
                        target="_blank"
                      >
                        Distributor Empanelment Details
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Products</p>
                  <ul>
                    <li>
                      <a href="/products">All</a>
                    </li>
                    <li>
                      <a href="/products/Equity">Equity </a>
                    </li>
                    <li>
                      <a href="/products/Fixed-Income">Fixed Income</a>
                    </li>
                    {/* <li>
                      <a href="/products/debt">Fixed Income</a>
                    </li> */}
                    <li>
                      <a href="/products/Hybrid">Hybrid</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Communication Hub</p>
                  <ul>
                    <li>
                      <a href="Communication-Hub/Media-Interaction">
                        Media Interaction
                      </a>
                    </li>
                    {/* <li>
                      <a href="Communication-Hub/Market-Outlook">
                        Market Outlook
                      </a> */}
                    {/* </li> */}
                    {/* <li>
                      <a href="Communication-Hub/Product-Outlook">
                        Product Outlook
                      </a>
                    </li> */}
                    <li>
                      <a href="Communication-Hub/Events">Events</a>
                    </li>
                    <li>
                      <a href="Company-Boilerplate">Company Boilerplate</a>
                    </li>
                    <li>
                      <a href="/SIDdisclosures/Penaltiesndpending">
                        Penalties and Pending Litigation
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Reach Us</p>
                  <ul>
                    <li>
                      <a href="Reach-Us/Our-Branches">Our Branches</a>
                    </li>
                    <li>
                      <a href="Reach-Us/KFinBranches">KFin Branches</a>
                    </li>
                    <li>
                      <a href="Reach-Us/CompanyDetails">Company Details</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Knowledge Hub</p>
                  <ul>
                    <li>
                      <a href="/FAQs">
                        FAQs
                      </a>
                    </li>
                    <li>
                      <a href="knowledgehubkyc">
                        KYC
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.jmfinancialmf.com/CMS/downloads/Investor%20Awareness%20Program/AMFI%20Presentation/InvestorsAwarenessProgrampresentation.pdf"
                        target="_blank"
                        rel="noreferrer"
                      >
                        AMFI Investor Education PPT{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.jmfinancialmf.com/CMS/downloads/Investor Awareness Program/IAP Schedule/IAPSchedule16.xlsx"
                        target="_blank"
                        rel="noreferrer"
                      >
                        IAP Schedule
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://docviewer.jmfinancialmf.com/OneLessOneMore/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        IAP - OneLess - OneMore SIP
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.jmfinancialmf.com/sippaglu.html"
                        target="_blank"
                        rel="noreferrer"
                      >
                        IAP - SIP Paglu
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="https://www.jmfinancialmf.com/savetaxstartsip.html"
                        target="_blank"
                       rel="noreferrer">
                        IAP - TAX ki hui Katauti, SIP ki karo Badhoti
                      </a>
                    </li> */}
                    <li>
                      <a
                        href="cyber-security-awareness"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Cyber Security Awareness
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-menu">
                  <p className="footer-heading">Customer Service</p>
                  <ul>
                    {/* <li><a href='/CustomerServices/Feedback-Suggestion'>Feedback / Suggestion</a></li> */}
                    {/* <li><a href='CustomerServices/Contact-Us-Form'>Contact Us Form</a></li> */}

                    <li className="liGet_in_touch" onClick={handleChange}>
                      <a href="javascript:void(0)">Contact Us Form</a>
                    </li>
                    <li>
                      <a href="/ODRPortal">ODR-SCORES Portal Link</a>
                    </li>
                    {/* <li>
                    {/* <li>
                      <a
                        href="https://mfs.kfintech.com/panupdation/"
                        target="_blank"
                       rel="noreferrer">
                        Update PAN
                      </a>
                    </li> */}
                    <li>
                      <a href="/Grievance">Grievance Redressal Process</a>
                    </li>
                    <li>
                      <a
                        href="https://mfs.kfintech.com/fatcaupdate"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Update FATCA/CRS Details
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://mfs.kfintech.com/investor/General/NCTNomineeUpdation"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Update Nominee{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://mfs.kfintech.com/investor/Transact/ChangeFolioEmail"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Change in Contact Details
                      </a>
                    </li>

                    <li>
                      <a
                        href="javascript:void(0)"
                        // onClick={(e) => {
                        //   e.preventDefault();
                        //   e.handleOpenPopup();
                        // }}
                        onClick={() => handleOpenPopup()}
                      >
                        MITRA (Mutual Fund Investment Tracing and Retrieval
                        Assistant)
                      </a>
                    </li>
                    <li>
                      <a
                        href={IncapacitatedInvestor}
                        target="_blank"
                        rel="noreferrer"
                      >
                        (SOP) for dealing with Incapacitated Investors
                      </a>
                    </li>
                     <li>
                      <a
                        href="Mutual-Fund-Conversion-Physical-to-Demat"
                        // target="_blank"
                        rel="noreferrer"
                      >
                        Mutual Fund Conversion – Physical to Demat
                      </a>
                    </li>

                     <li>
                      <a
                        href="https://mfs.kfintech.com/OnlineSubmissionForm121/Inv_Form121.aspx"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Online submission of Form 121
                      </a>
                    </li>
                           <li>
                      <a
                        href="https://mfs.kfintech.com/investor/LEI/LEIstatusUpdate"
                        target="_blank"
                        rel="noreferrer"
                      >
                        LEI(Legal Entity Identifier) updation
                      </a>
                    </li>
                     <li>
                      <a
                        href="https://mfs.kfintech.com/investor/General/eNACHOTMCancellation"
                        target="_blank"
                        rel="noreferrer"
                      >
                        ENACH / OTM Cancellation
                      </a>
                    </li>


                    {/* POPUP Modal Start  */}
                    <Modal
                      show={show}
                      onHide={handleClosePopup}
                      backdrop="static"
                      keyboard={true}
                      centered
                      className="modal modal-home"
                    >
                      {/* <div className="close-btn" onClick={handleClosePopup}>
                        <AiFillCloseCircle className="btncl" />
                      </div> */}

                      {/* <div className="btnDiv">
                        <div className="" onClick={handleClosePopup}>
                          <AiFillCloseCircle className="btncl" />
                        </div>
                      </div> */}

                      {/* Modal Body */}
                      <Modal.Body id="modal_info">
                        <div className="btnDiv">
                          <div className="" onClick={handleClosePopup}>
                            <AiFillCloseCircle className="btncl" />
                          </div>
                        </div>
                        <div style={{ padding: "10px" }}>
                          <p className="modal_info">
                            Introducing MITRA (Mutual Fund Investment Tracing
                            and Retrieval Assistant) – A Service platform for
                            investors to trace inactive and unclaimed Mutual
                            Fund folios.{" "}
                            <a
                              href="https://app.mfcentral.com/links/mitra"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{color: "#013C66"}}
                            >
                              Click Here to Visit.
                            </a>
                            .<br></br>
                          </p>
                          <p className="modal_info">
                            Mutual Fund investors sometimes lose track of their
                            investments, considering investments might have been
                            made in physical form with bare minimum KYC details.
                            Due to non-availability of PAN, email ID, or valid
                            address, it is also possible that MF folios may not
                            appear in the unitholder’s Consolidated Account
                            Statement. Thus, inactivity in Mutual Fund folios
                            could be on account of the investor losing track of
                            his/her investment, demise, etc. Such inactive
                            folios may become susceptible to fraudulent
                            redemptions.
                          </p>
                          <p className="modal_info">
                            In order to address these concerns, Mutual Fund
                            RTA’s have developed a platform called Mutual Fund
                            Investment Tracing and Retrieval Assistant or MITRA.
                            This platform provides investors with a searchable
                            database of inactive and unclaimed Mutual Fund
                            folios at an industry-level which will empower
                            investors in the following manner:
                          </p>
                          <ul>
                            <li>
                              Enable investors to identify overlooked
                              investments or any investments made by any other
                              person for which he/she may be a rightful legal
                              claimant.
                            </li>
                            <li>
                              Encourage investors to do KYC as per the current
                              norms, thus reducing the number of non-KYC
                              compliant folios.
                            </li>
                            <li>
                              The MITRA platform will lead to a reduction in
                              unclaimed Mutual Fund folios.
                            </li>
                            <li>
                              Contribute towards building a transparent
                              financial ecosystem and provide a reliable medium
                              for investors to find their inactive and unclaimed
                              Mutual Fund investments.
                            </li>
                            <li>
                              Build and incorporate mitigants against fraud
                              risk.
                            </li>
                          </ul>
                          <p className="modal_info">
                            Thus, if you have any unclaimed folios and wish to
                            claim them, then the process is now very easy with
                            MITRA.{" "}
                            <a
                              href="https://app.mfcentral.com/links/mitra"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{color: "#013C66"}}
                            >
                              Click Here to Visit.
                            </a>
                          </p>
                        </div>
                      </Modal.Body>

                      {/* Modal Footer */}
                    </Modal>

                    {/* <li><a href='https://smartodr.in/login' target="blank">ODR Portal Link</a></li> */}
                  </ul>
                </div>
                {/* <div className="footer-menu">
                  <h3>Perspectives</h3>
                  <ul>
                    <li>
                      <a href="/Perspectives">Thought Leadership Articles </a>
                    </li>
                  </ul>
                </div> */}

                <div className="footer-menu">
                  <div className="d-flex flex-md-row  icon-col footer-social-links">
                    <div>
                      <span className="footer-follow-us">Follow us on</span>
                    </div>
                    <div>
                      <ul className="d-flex felx-row ">
                        {/* <li><a href=""><img src={twitter} alt="twitter" className='img-fluid' /></a></li>
                                    <li><a href=""><img src={facebook} alt="facebook" className='img-fluid' /></a></li> */}
                        <li>
                          <a
                            target="_blank"
                            href="https://www.youtube.com/@JMFinancial_MutualFund"
                            rel="noreferrer"
                          >
                            <img
                              src={youtubeIcon}
                              alt="youtube"
                              className="footer-social-icon"
                              height={30}
                              width={30}
                              style={{marginTop : "0.5px"}}
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            href="https://www.linkedin.com/company/jm-financial-mutual-fund-ltd/mycompany/"
                            rel="noreferrer"
                          >
                            <img
                              src={linkedin}
                              alt="linkedin"
                              className="footer-social-icon"
                              height={30}
                              width={30}
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            href="https://www.instagram.com/jmfinancialmutualfund/"
                            rel="noreferrer"
                          >
                            <img
                              src={instagram}
                              alt="instagram"
                               className="footer-social-icon"
                              height={30}
                              width={30}
                            />
                          </a>
                        </li>
                         <li>
                          <a
                            target="_blank"
                            href="https://whatsapp.com/channel/0029Vb6BSCCHLHQSMV8eOH1J"
                            rel="noreferrer"
                          >
                            <img
                              src={Whatsapp}
                              alt="Whatsapp"
                              className="footer-social-icon"
                              height={30}
                              width={30}
                            />
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            href="https://www.facebook.com/profile.php?id=61576635545617"
                            rel="noreferrer"
                          >
                            <img
                              src={Facebook}
                              alt="Facebook"
                              className="footer-social-icon"
                              height={30}
                              width={30}
                            />
                          </a>
                        </li>
                      </ul>
                      
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col sm={12} className="investment">
              
                Mutual Fund investments are subject to market risks, read all
                scheme related documents carefully.
              
            </Col>
          </Row>
        </Container>
      </section>
      <section className="footer-links" aria-label="Footer links">
        {/* <Container  className='p-0'> */}
        {/* <Row>
                        <Col sm={12}> */}
        <ul className="footer-bottom-links">
          <li>
            <a href="/Disclaimer">Disclaimer</a>
          </li>
          <li>
            <a href="/Privacy-Policy">Privacy Policy</a>
          </li>
          <li>
            <a href="/Terms-and-Conditions">Terms and Condition </a>
          </li>
          {/* <li> 
             {DataMisc &&
              DataMisc.map(({ FileName, SubCategoryName }) => (
                <a href={FileName} target="blank">
                  {console.log("Filename :", FileName)}
                  Scheme Expense Ratio Excel
                </a>
              ))}

            {/* <a onClick={handleTER} target="_self" className="cursorpointer">
                            
                            Scheme Expense Ratio
                            </a> 
          </li> */}
          <li>
            <a href="/Scheme-Expense-Ratio">Scheme Expense Ratio </a>
          </li>
          <li>
            <a href="downloads/statutory-disclosure">Voting Policy</a>
          </li>
          <li>
            <a href="/Transmission-Units">Transmission Units</a>
          </li>
          <li>
            <a href="/SIDdisclosures">SID Related Disclosures</a>
          </li>
           {/* <li>
            <a href="/Factsheet-disclosures">Factsheets Disclosures</a>
          </li> */}
          <li>
            <a
              href="https://www.amfiindia.com/otherdata/fund-performance/information-ratio"
              target="_blank"
              rel="noreferrer"
            >
              Information Ratio
            </a>
          </li>
        </ul>
        {/* </Col>
                    </Row> */}
        {/* </Container> */}
      </section>
      <section className="footer-sc-1" aria-label="Registered office details">
        <Container>
          <Row>
            <Col sm={12}>
              {/* {data && data.map(({ branchname, address, landline, latitude, longitude }) => ( */}
              <div className="address-pnl-main">
                <div className="address-pnl common-address-pnl">
                  <p className="footer-contact">Address</p>
                  <p>
                    One International Centre, 22nd Floor, Tower 2, Senapati
                    Bapat Marg, Prabhadevi, Mumbai – 400013.
                  </p>
                  {/* <p>{address}</p> */}
                </div>
                <div className="phone-pnl common-address-pnl">
                  <p className="footer-contact">Phone No.</p>
                  <p>+91 22 61987777 / 33797777</p>
                  <p>Toll Free No. - 1800 1038 345</p>
                  {/* <p>{landline}</p> */}
                </div>
                <div className="email-pnl common-address-pnl">
                  <p className="footer-contact">Email Id</p>
                  <p>
                    <a href="mailto:investor@jmfl.com">investor@jmfl.com</a>
                  </p>
                  <p>
                    <a href="mailto:partnercare@jmfl.com">
                      partnercare@jmfl.com
                    </a>
                  </p>
                </div>
                <div className="cin-pnl common-address-pnl">
                  <p className="footer-contact">CIN</p>
                  {/* <p>U256557169278F26769778-08</p> */}
                  <p>U65991MH1994PLC078879</p>
                </div>
              </div>
              {/* )
                            )} */}
            </Col>
          </Row>
        </Container>
      </section>
      <section className="footer-sc-2" aria-label="Copyright and site credits">
        <Container>
          <Row>
            <Col lg={6} md={12}>
              <div className="copyright-pnl">
                Copyright {currentYear} JM Financial Mutual Fund. All rights
                reserved.
              </div>
            </Col>
            <Col lg={6} md={12}>
              <div className="copyright-pnl right">
                Designed, Developed and Maintained by{" "}
              </div>
              <div className="copyright-pnl right">
                <a target="_blank" href="http://www.cmots.com/">
                  <strong>CMOTS InfoTech</strong>
                </a>{" "}
                (ISO 9001:2022 & ISO/IEC 27001:2022 Certified)
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Footer;
